import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { APP_CONFIG, Settings } from '../config/settings';
import { DocumentAttributeFieldOption } from '../shared/lib/compliance-shared/document-attributes-form/document-attributes-form.store';
import { PagingToken } from '../shared/models/core';
import { arrayToQuery, combine } from '../shared/utilities/route';
import { Requirement } from './models/requirement';
import { DocumentTypeConfiguration } from './models/requirement-descriptions.model';

/**
 * @deprecated Do not use this service.  Use service(s) from "src/app/compliance/api" or "src/app/compliance/api/migration"
 */
@Injectable({ providedIn: 'root' })
export class RequirementService {
    private readonly coreApiCompliancePath: string;
    private readonly coreApiReqDescriptionPath: string;

    constructor(private http: HttpClient, @Inject(APP_CONFIG) settings: Settings) {
        this.coreApiCompliancePath = combine(settings.coreAPIUrl, 'ayanova/compliance/requirements');
        this.coreApiReqDescriptionPath = combine(settings.coreAPIUrl, 'ayanova/compliance/requirement');
    }

    // ** RequirementsController.GetRequirements
    getRequirements(idList: number[]): Observable<PagingToken<Requirement[]>> {
        return this.http.get<PagingToken<Requirement[]>>(
            `${this.coreApiCompliancePath}?${arrayToQuery('idList', idList)}`
        );
    }

    // ** RequirementsController.UpdateRequirementExpirationDate
    updateRequirementExpirationDate(requirementId: number, newDate: Date) {
        const data = { expirationDate: newDate };
        return this.http.put(`${this.coreApiCompliancePath}/${requirementId}/expiration-date`, data);
    }

    // ** RequirementsController.UpdateRequirementLicensureState
    updateRequirementLicensureState(requirementId: number, selectedOption: DocumentAttributeFieldOption) {
        return this.http.put(`${this.coreApiCompliancePath}/${requirementId}/licensure-state`, selectedOption);
    }

    // ** RequirementsController.GetLicensureStates
    getLicensureStates(): Observable<DocumentAttributeFieldOption[]> {
        return this.http.get<DocumentAttributeFieldOption[]>(`${this.coreApiCompliancePath}/licensure-states`);
    }

    // RequirementDescriptionController.GetWinningDescriptionsByContractId
    getDocumentTypeRequirementDescriptionByContractId(
        requirementId: number,
        contractId: number,
        includeInternal: boolean,
        includeExternal: boolean
    ) {
        const url = `${this.coreApiReqDescriptionPath}/${requirementId}/contract/${contractId}/description?includeInternal=${includeInternal}&includeExternal=${includeExternal}`;
        return this.http.get<DocumentTypeConfiguration[]>(url).pipe(
            tap((requirements) => {
                requirements.sort((a, b) => {
                    return a.documentTypeDescriptionTypeDisplayOrder - b.documentTypeDescriptionTypeDisplayOrder;
                });
            })
        );
    }
}
